import * as React from 'react';
import * as _ from 'lodash';
import {TablesState, TableState} from './actions';
import {getUpdatedData} from './selectors';
import {InferableComponentEnhancer, InferableComponentEnhancerWithProps} from 'recompose';
import {TableContext, TableContextConsumer} from './createTableContext';
import {connect} from 'react-redux';

export interface WithTableOptions<TableStateProps> {
  props?: TableStateProps[];
}

type WrappedComponentProps = TableContext & {componentProps: object};

type Props = TableState & TableContext;

export default function<TableStateProps extends keyof Props = keyof Props>({
  props,
}: WithTableOptions<TableStateProps> = {}): InferableComponentEnhancer<Pick<Props, TableStateProps>> {
  return function(WrappedComponent) {
    const ConnectedWrappedComponent: React.ComponentClass<WrappedComponentProps> = connect<
      TableState,
      {},
      WrappedComponentProps,
      Pick<Props, TableStateProps>
    >(
      ({table}: {table: TablesState}, {name}) => {
        const tableState: TableState = table[name] || ({} as TableState);
        return {
          ...tableState,
          data: getUpdatedData(tableState),
        };
      },
      null,
      (stateProps, dispatchProps, ownProps) => {
        if (props) {
          return {
            ..._.pick(stateProps, props),
            ..._.pick(ownProps, props),
            ...ownProps.componentProps,
          } as Pick<Props, TableStateProps>;
        }
        return {
          ...stateProps,
          ..._.omit(ownProps, 'componentProps'),
          ...ownProps.componentProps,
        } as Props;
      }
    )(WrappedComponent as any);
    return (props: object) => (
      <TableContextConsumer>
        {(tableProps: TableContext) => <ConnectedWrappedComponent componentProps={props} {...tableProps} />}
      </TableContextConsumer>
    );
  };
}
